import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

interface LoadingStateProps {
  rows?: number;
  message?: string;
  className?: string;
}

export const LoadingSpinner: React.FC<{ className?: string }> = ({ className = '' }) => (
  <ArrowPathIcon className={`animate-spin ${className}`} />
);

export const SkeletonRow: React.FC = () => (
  <div className="flex items-center gap-4 px-6 py-4 border-b border-slate-100 last:border-0">
    <div className="h-8 w-8 rounded-full bg-slate-200 animate-pulse shrink-0" />
    <div className="flex-1 space-y-2">
      <div className="h-3.5 w-48 bg-slate-200 rounded animate-pulse" />
      <div className="h-3 w-32 bg-slate-100 rounded animate-pulse" />
    </div>
    <div className="h-6 w-16 bg-slate-100 rounded-full animate-pulse" />
    <div className="h-4 w-24 bg-slate-100 rounded animate-pulse" />
  </div>
);

export const LoadingState: React.FC<LoadingStateProps> = ({ rows = 6, message, className = '' }) => (
  <div className={`${className}`}>
    {message ? (
      <div className="flex flex-col items-center justify-center py-16 gap-4">
        <ArrowPathIcon className="w-8 h-8 text-slate-400 animate-spin" />
        <p className="text-sm font-medium text-slate-500">{message}</p>
      </div>
    ) : (
      Array.from({ length: rows }).map((_, i) => <SkeletonRow key={i} />)
    )}
  </div>
);

export const InlineLoader: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`flex items-center justify-center py-8 ${className}`}>
    <ArrowPathIcon className="w-6 h-6 text-slate-400 animate-spin" />
  </div>
);

export default LoadingState;
